import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import "./App.css";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Submit from "./pages/Submit";
import Earnings from "./pages/Earnings";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import Settings from "./pages/Settings";
import ManagePartners from "./pages/ManagePartners";
import ManageAgents from "./pages/ManageAgents";
import LeadGuide from "./pages/LeadGuide";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin" color="#D62828" size={32} /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function ManagerOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin" color="#D62828" size={32} /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "partner") return <Navigate to="/submit" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/submit" element={<Protected><Submit /></Protected>} />
            <Route path="/earnings" element={<Protected><Earnings /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/edit-profile" element={<Protected><EditProfile /></Protected>} />
            <Route path="/lead-guide" element={<Protected><LeadGuide /></Protected>} />

            <Route path="/settings" element={<ManagerOnly><Settings /></ManagerOnly>} />
            <Route path="/manage-partners" element={<ManagerOnly><ManagePartners /></ManagerOnly>} />
            <Route path="/manage-agents" element={<ManagerOnly><ManageAgents /></ManagerOnly>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
